import { setCookie } from 'utils/cookie.helper';
import { getDomain } from 'utils/get-domain.helper';

export const setConfigurationIdCookie = ({
  projectConfigurationId,
  projectConfigurationCookieName,
}: {
  projectConfigurationId: string;
  projectConfigurationCookieName: string;
}) => {
  const domain = getDomain();
  setCookie(projectConfigurationCookieName, projectConfigurationId, {
    path: '/',
    domain,
    expires: new Date(new Date().getFullYear() + 1, 12, 31),
  });
};
